import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component WarningTriangleSmallIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <WarningTriangleSmallIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <WarningTriangleSmallIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const WarningTriangleSmallIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    svgRef?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      width={12}
      height={12}
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="WarningTriangleSmallIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        d="M6.54 1.123c.19.093.347.233.45.403l4.872 7.982c.298.49.097 1.102-.45 1.369-.166.08-.352.123-.541.123H1.129C.505 11 0 10.548 0 9.991c0-.169.047-.335.138-.483l4.871-7.982c.298-.49.984-.67 1.531-.403zM6 2l-5 8h10L6 2zm0 4a1.5 1.5 0 110 3 1.5 1.5 0 010-3z"
        fillRule="evenodd"
      />
    </svg>
  )
);
WarningTriangleSmallIcon.displayName = "WarningTriangleSmallIcon";
export default WarningTriangleSmallIcon;
